export enum PurchasingDashboardPages {
    Activity = "activity",
    Cashback = "cashback",
    Discounts = "discounts",
    FAQ = "FAQ",
    Payments = "payments",
    Products = "products",
}

export enum PurchasingDashboardActivityPages {
    Cashback = "cashback",
    Receipts = "allReceipts",
}

export const PurchasingDashboardJobTitleDefaultValue = "--";
